import { Injectable, inject } from '@angular/core';
import { AuthService } from '@feature/auth';
import { NavController } from '@ionic/angular';
import { UISnackbarService } from '@ui/components';
import { GraphQLFormattedError } from 'graphql/index';
import { Observable } from 'rxjs';
import { GraphqlErrorClassification } from './graphql-error-classification.enum';

@Injectable({
  providedIn: 'root',
})
export class GraphqlService {
  private readonly authService: AuthService = inject(AuthService);
  private readonly snackbar: UISnackbarService = inject(UISnackbarService);
  private readonly navCtrl: NavController = inject(NavController);

  token$(): Observable<string | null> {
    return this.authService.getToken$();
  }

  shouldLogout(error: GraphQLFormattedError): boolean {
    return error.extensions && error.extensions['classification'] === GraphqlErrorClassification.UNAUTHORIZED;
  }

  logout(): void {
    this.snackbar.showNeutral('Your session has expired, please log in again');
    this.authService.logout();
    this.navCtrl.navigateForward(['/']);
  }
}
